
import React from 'react';
// images
import highResDesktopImageWebp from './images/special-needs-planning-hero-desktop.webp';
import highResMobileImageWebp from './images/special-needs-planning-hero-mobile.webp';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='special-needs-planning-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Special needs financial planning'
      headingText='A plan for your family&#39;s best life.'
      descriptionText={<>Caring for a loved one with special needs can present unique challenges. We&#39;ll help you put a plan in place to do the things that are important to your family today, and every day after.</>}
      ctaPrimary={{
        linkUrl: '#in-page-lead-section-container',
        buttonText: 'Start planning',
        ariaLabel: 'Start planning with a financial advisor',
        children: '',
      }}
      backgroundImageAriaLabel='a smiling mother holds her laughing toddler son in a swimming pool during a sunny Summer day'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      backgroundImageMobileLowRes='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
